<template>
  <div class="category-container">
    <h2>Category and Subcategory Management</h2>

    <button @click="showAddCategoryForm = true">Add Category</button>
    <button @click="showAddSubcategoryForm = true">Add Subcategory</button>

    <!-- Add Category Modal -->
    <div v-if="showAddCategoryForm" class="modal-overlay" @click.self="showAddCategoryForm = false">
      <div class="modal-content">
        <h3>Add Category</h3>
        <form @submit.prevent="addCategory">
          <input v-model="newCategory.title" placeholder="Category Title" required/>
          <button type="submit">Save</button>
          <button type="button" @click="showAddCategoryForm = false">Cancel</button>
        </form>
      </div>
    </div>

    <!-- Add Subcategory Modal -->
    <div v-if="showAddSubcategoryForm" class="modal-overlay" @click.self="showAddSubcategoryForm = false">
      <div class="modal-content">
        <h3>Add Subcategory</h3>
        <form @submit.prevent="addSubcategory">
          <input v-model="newSubcategory.title" placeholder="Subcategory Title" required/>
          <select v-model="newSubcategory.categoryId" required>
            <option v-for="category in categories" :key="category.id" :value="category.id">
              {{ category.title }}
            </option>
          </select>
          <button type="submit">Save</button>
          <button type="button" @click="showAddSubcategoryForm = false">Cancel</button>
        </form>
      </div>
    </div>

    <!-- Categories and Subcategories Table -->
    <table class="table">
      <thead>
      <tr>
        <th>Category</th>
        <th>Subcategories</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="category in categories" :key="category.id">
        <td>{{ category.title }}</td>
        <td>
          <ul>
            <li v-for="sub in category.subcategories" :key="sub.id">
              {{ sub.name }}
              <button @click="editSubcategory(sub)">Edit</button>
              <button @click="deleteSubcategory(sub.id)">Delete</button>
            </li>
          </ul>
        </td>
        <td>
          <button @click="editCategory(category)">Edit</button>
          <button @click="deleteCategory(category.id)">Delete</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      categories: [],
      showAddCategoryForm: false,
      showAddSubcategoryForm: false,
      newCategory: {title: ''},
      newSubcategory: {title: '', categoryId: null},
    };
  },
  methods: {
    fetchCategories() {
      axios.get('/dashboard/categories/')
          .then(response => {
            this.categories = response.data;
          })
          .catch(error => console.error(error));
    },
    addCategory() {
      axios.post('/dashboard/categories/', this.newCategory)
          .then(() => {
            this.fetchCategories();
            this.showAddCategoryForm = false;
            this.newCategory.title = '';
          })
          .catch(error => console.error(error));
    },
    addSubcategory() {
      axios.post('/dashboard/subcategories/', this.newSubcategory)
          .then(() => {
            this.fetchCategories();
            this.showAddSubcategoryForm = false;
            this.newSubcategory.title = '';
            this.newSubcategory.categoryId = null;
          })
          .catch(error => console.error(error));
    }
  },
  mounted() {
    this.fetchCategories();
  },
};
</script>

<style scoped>
.category-container {
  padding: 20px;
}

button {
  margin: 5px;
  padding: 10px 15px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.table th, .table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.table th {
  background-color: #f4f4f4;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-content h3 {
  margin-top: 0;
}

.modal-content form {
  display: flex;
  flex-direction: column;
}

.modal-content input,
.modal-content select,
.modal-content button {
  margin: 10px 0;
  padding: 10px;
  border-radius: 5px;
}

.modal-content button {
  background-color: #007bff;
  color: white;
  border: none;
}

.modal-content button:hover {
  background-color: #0056b3;
}
</style>
